<div class="relative h-[340px] rounded-[18px] bg-white/[0.02] border border-white/[0.06] overflow-hidden">
  <canvas #canvas class="block w-full h-full"></canvas>
</div>
